import { useNavigate } from 'react-router-dom';
import AppPageIntro from '@/components/AppPageIntro';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import {
  Receipt,
  PiggyBank,
  ShoppingCart,
  FileText,
  Landmark,
  Heart,
  CalendarRange,
  Settings,
} from 'lucide-react';

const overviewTiles = [
  {
    key: 'transactions',
    title: 'Transacties',
    description: 'Bekijk inkomsten en uitgaven',
    icon: Receipt,
    path: '/transactions',
  },
  {
    key: 'reservations',
    title: 'Reserveringen',
    description: 'Potjes, buffers en spaardoelen',
    icon: PiggyBank,
    path: '/reservations',
  },
  {
    key: 'groceries',
    title: 'Boodschappen',
    description: 'Weekplan en bonnen',
    icon: ShoppingCart,
    path: '/groceries',
  },
  {
    key: 'contracts',
    title: 'Contracten',
    description: 'Dossier en signalering',
    icon: FileText,
    path: '/contracts',
  },
  {
    key: 'fixed-costs',
    title: 'Vaste lasten',
    description: 'Maanddruk en betaaldagen',
    icon: Landmark,
    path: '/fixed-costs',
  },
  {
    key: 'health',
    title: 'Gezondheid',
    description: 'Zorg en financiële impact',
    icon: Heart,
    path: '/health',
  },
  {
    key: 'life-planning',
    title: 'Levensplanning',
    description: 'Vooruitkijken en momenten plannen',
    icon: CalendarRange,
    path: '/life-planning',
  },
  {
    key: 'settings',
    title: 'Instellingen',
    description: 'Rekeningen, profiel en beheer',
    icon: Settings,
    path: '/settings',
  },
];

export default function OverviewPage() {
  const navigate = useNavigate();
  const churchMode = localStorage.getItem('app_profile') === 'church';
  const visibleTiles = churchMode
    ? overviewTiles.filter((tile) => ['transactions', 'reservations', 'settings'].includes(tile.key))
    : overviewTiles;

  return (
    <div className="space-y-6" data-testid="overview-page">
      <AppPageIntro
        title="Overzicht"
        description="Open hier snel alle onderdelen van budgettoppers zonder dubbele navigatie."
        compact
      />

      <Card className="shadow-card">
        <CardHeader className="pb-3">
          <CardTitle className="font-heading">Onderdelen</CardTitle>
        </CardHeader>
        <CardContent className="grid grid-cols-2 gap-3 pt-0 pb-2">
          {visibleTiles.map((tile) => (
            <button
              key={tile.key}
              type="button"
              onClick={() => navigate(tile.path)}
              className="rounded-2xl border bg-background p-4 text-left transition-all hover:shadow-card-hover"
            >
              <div className="mb-3 flex h-11 w-11 items-center justify-center rounded-2xl bg-primary/10 text-primary">
                <tile.icon className="h-5 w-5" />
              </div>
              <p className="font-medium">{tile.title}</p>
              <p className="mt-1 text-sm text-muted-foreground">{tile.description}</p>
            </button>
          ))}
        </CardContent>
      </Card>
    </div>
  );
}
